<script lang="ts">
  import { applyAction, enhance } from '$app/forms';
  import { refreshAll } from '$app/navigation';
  import Modal from '#lib/components/Modal.svelte';
  import { addToast } from '#lib/components/page/Toasts.svelte';

  let {
    open = $bindable(false),
    datacenter = { id: -1, name: 'Placeholder' },
  }: {
    open: boolean;
    datacenter?: { id: number; name: string };
  } = $props();
</script>

<Modal header="Delete datacenter {datacenter.name}" bind:open>
  <form
    method="post"
    action="?/deleteDatacenter"
    use:enhance={({ formElement }) => {
      return async ({ result }) => {
        await applyAction(result);

        if (result.type === 'success') {
          formElement.reset();
          await refreshAll();
          open = false;
        } else if (result.type === 'failure') {
          addToast({ message: String(result.data?.error), type: 'error' });
          open = false;
        }
      };
    }}
  >
    <input type="number" value={datacenter.id} name="id" hidden />
    <p>All related systems will be moved to Unassigned, no other data will be removed.</p>
    <div class="modal-action">
      <button class="btn btn-secondary btn-ghost" type="reset" onclick={() => (open = false)}>
        Cancel
      </button>
      <button type="submit" class="btn btn-error">Delete</button>
    </div>
  </form>
</Modal>
